import React, { useContext, useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import { FeatureFlagContext } from 'src/store/FeatureFlagContext'
import { UserContext } from 'src/store/UserContext'
import { ConfigContext } from 'src/store/ConfigContext'
import { PrinterContext } from 'src/store/PrinterContext'
import {
  ACTIVATION_PHASE,
  BIZ_MODEL,
  EMPTY_FUNCTION,
  FEATURE_FLAG_KEYS,
  PLATFORM_IDENTIFIER
} from 'src/config/constants'

export const ActivationContext = React.createContext({
  phase: 0,
  setPhase: EMPTY_FUNCTION,
  totalPhases: ACTIVATION_PHASE.DEVICE_REGISTRATION,
  rtpEligible: false,
  shortcutsEligible: false
})

const ActivationProvider = (props) => {
  const { flags } = useContext(FeatureFlagContext)
  const { selectedBizModel } = useContext(UserContext)
  const { isSmbSmallville } = useContext(ConfigContext)
  const { isMultiFunction, platformIdentifier } = useContext(PrinterContext)
  const [phase, setPhase] = useState(0)
  const rtpEligible =
    selectedBizModel === BIZ_MODEL.E2E &&
    flags?.[FEATURE_FLAG_KEYS.enableRtpValidation]
  const shortcutsEligible = isSmbSmallville && isMultiFunction
  const isGen2 = platformIdentifier === PLATFORM_IDENTIFIER.GEN_2
  const getBasePhases = () => {
    if (rtpEligible) return ACTIVATION_PHASE.RTP_VALIDATION
    if (isGen2) return ACTIVATION_PHASE.GEN2_DEVICE
    return ACTIVATION_PHASE.DEVICE_REGISTRATION
  }
  const totalPhases = getBasePhases() + (shortcutsEligible ? 1 : 0)

  const state = useMemo(
    () => ({
      phase,
      setPhase,
      totalPhases,
      rtpEligible,
      shortcutsEligible
    }),
    [phase, rtpEligible, totalPhases, shortcutsEligible]
  )

  return (
    <ActivationContext.Provider value={state}>
      {props.children}
    </ActivationContext.Provider>
  )
}

ActivationProvider.propTypes = {
  children: PropTypes.node
}

export default ActivationProvider
